import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { IncludeContent } from 'bricks/IncludeContent';
import { Button } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function SPMessage({ messageText, buttonText, url }) {
  return messageText ?
      <div className={cx('component')}>
        <IncludeContent htmlContent={messageText} className={cx('message')} />
        <Button href={url}>{buttonText}</Button>
      </div>
    : null;
}

SPMessage.propTypes = {
  messageText: PropTypes.string,
  buttonText: PropTypes.string,
  url: PropTypes.string,
};
